module.exports = __webpack_public_path__ + "img/logo.64ee3d80.png";